import {createAction} from "redux-act";
import {ISwing} from "modules/reducers/swing";

export const fetchSwingsJsonRequest = createAction();
export const fetchSwingsJsonSuccess = createAction<ISwing[]>();